import { uiText, useUiLanguage } from '@/i18n/interface';

import React from 'react';
import { Badge } from "@/components/ui/badge";

interface SessionStatusProps {
  status?: 'scheduled' | 'completed' | 'cancelled';
  isPastDate: boolean;
}

const SessionStatus: React.FC<SessionStatusProps> = ({ status, isPastDate }) => {
  useUiLanguage();
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'completed':
        return <Badge variant="secondary" className="bg-green-100 text-green-800">{uiText("Completed")}</Badge>;
      case 'cancelled':
        return <Badge variant="destructive">{uiText("Cancelled")}</Badge>;
      default:
        return <Badge variant="outline">{uiText("Scheduled")}</Badge>;
    }
  };

  return (
    <div className="flex items-center gap-2">
      {status && getStatusBadge(status)}
      {isPastDate && status === 'scheduled' && (
        <Badge variant="outline" className="bg-yellow-100 text-yellow-800">
          {uiText("Pending Closure")}</Badge>
      )}
    </div>
  );
};

export default SessionStatus;
